export default __webpack_public_path__ + "static/media/withdraw-funds.0019a4ca.svg";